/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetDescendantsQueryResponse, HierarchiesControllerGetDescendantsPathParams, HierarchiesControllerGetDescendantsQueryParams, HierarchiesControllerGetDescendants401, HierarchiesControllerGetDescendants403 } from "../../models/hierarchiesController/HierarchiesControllerGetDescendants";

function getHierarchiesControllerGetDescendantsUrl(scopeId: HierarchiesControllerGetDescendantsPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/hierarchies/${scopeId}/descendants` as const }  
  return res
}

/**
 * @description Retrieve all child scopes recursively with optional depth limit. Supports filtering by scope type(s) using comma-separated values (e.g., scopeType=FILE,FOLDER)
 * @summary Get descendant scopes
 * {@link /api/v1/hierarchies/:scopeId/descendants}
 */
export async function hierarchiesControllerGetDescendants(scopeId: HierarchiesControllerGetDescendantsPathParams["scopeId"], params: HierarchiesControllerGetDescendantsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetDescendantsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetDescendants401 | HierarchiesControllerGetDescendants403>, unknown>({ method : "GET", url : getHierarchiesControllerGetDescendantsUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}